import { ListChecks, Search, BookOpen, List, FileText, Globe, Loader, Calendar, Mic, Bell, Wallet, Receipt, ArrowRightLeft, LayoutGrid, Plus, Pencil, Trash2, MessageSquare, Paperclip, Unlink, Tag, UserPlus, FolderOpen, FolderInput, Database, Microscope, Users, Share2, Send, Repeat, FileSpreadsheet, StickyNote, Undo2, History, LogOut, ScrollText, Zap, Calculator, Link2 } from 'lucide-react';

export const TOOL_ICONS = {
    search_documents: Search,
    search_within_document: Search,
    read_document: BookOpen,
    list_documents: List,
    open_folder: FolderOpen,
    move_document: FolderInput,
    research: Microscope,
    research_subagent: Microscope,
    rulebook_scribe: ScrollText,
    get_rulebook: ScrollText,
    edit_rulebook: ScrollText,
    context_cache: Database,
    light_chat: Zap,
    edit_document: FileText,
    create_document: FileText,
    document_author: FileText,
    doc_code_worker: FileText,
    delete_document: Trash2,
    delete_book: Trash2,
    rename_book: Pencil,
    delete_expenses: Trash2,
    query_conversation_data: MessageSquare,
    get_energy_status: Zap,
    web_search: Globe,
    calculate: Calculator,
    web_search_grounded: Globe,
    read_link: Link2,
    read_link_url_context: Link2,
    places_lookup: Link2,
    audio_transcription: Mic,
    embedding_index: Database,
    embedding_query: Database,
    create_calendar_event: Calendar,
    create_calendar_events: Calendar,
    resolve_calendar_package: Calendar,
    update_calendar_event: Calendar,
    delete_calendar_event: Trash2,
    delete_calendar_events: Trash2,
    list_calendar_events: Calendar,
    remove_event_invitation: UserPlus,
    create_reminder: Bell,
    list_reminders: Bell,
    update_reminder: Bell,
    delete_reminders: Trash2,
    // Notes engine (Notes & Reminders — Fase 1)
    create_note: StickyNote,
    list_notes: StickyNote,
    update_note: Pencil,
    delete_notes: Trash2,
    share_note: Share2,
    // Task List (#437)
    create_tasks: ListChecks,
    list_tasks: ListChecks,
    update_tasks: ListChecks,
    delete_tasks: Trash2,
    create_expense: Wallet,
    create_expense_batch: Wallet,
    create_expenses_from_image: Wallet,
    assign_expense_to_book: ArrowRightLeft,
    set_transaction_recurrence: Repeat,
    list_expenses: Wallet,
    get_expense: Receipt,
    export_financial_data: FileSpreadsheet,
    import_transactions_from_spreadsheet: FileSpreadsheet,
    match_documents_to_expenses: Paperclip,
    update_expense_categories: Tag,
    update_expense: Pencil,
    spreadsheet_import_mapping: FileSpreadsheet,
    search_transaction_items: Search,
    expense_extraction: Receipt,
    list_boards: LayoutGrid,
    get_board: LayoutGrid,
    create_board: Plus,
    rename_board: Pencil,
    rename_documents: Pencil,
    delete_boards: Trash2,
    leave_board: LogOut,
    move_column: LayoutGrid,
    rename_column: Pencil,
    reorder_column: ArrowRightLeft,
    delete_column: Trash2,
    create_board_label: Tag,
    rename_board_label: Tag,
    delete_board_label: Trash2,
    create_ticket: Plus,
    update_ticket: Pencil,
    update_tickets: LayoutGrid,
    reorder_ticket: LayoutGrid,
    delete_ticket: Trash2,
    delete_tickets: Trash2,
    add_ticket_comment: MessageSquare,
    list_ticket_comments: MessageSquare,
    delete_ticket_comments: Trash2,
    attach_document_to_ticket: Paperclip,
    attach_document_to_note: Paperclip,
    attach_documents_to_ticket: Paperclip,
    detach_documents_from_ticket: Unlink,
    search_tickets: Search,
    conversation_title: Tag,
    create_contact_from_text: UserPlus,
    // Teams (Agenda TO Contacts — Phase C / T5)
    list_teams: Users,
    get_team: Users,
    create_team: Users,
    add_team_members: UserPlus,
    remove_team_member: UserPlus,
    leave_team: UserPlus,
    delete_team: Trash2,
    share_document_to_team: Share2,
    share_book_to_team: Share2,
    create_team_event: Calendar,
    // PAI-to-PAI direct send + Internal Secretary (Agenda TO Contacts Phase D / T6 + T4)
    send_document_to_contact: Send,
    send_contact_card: UserPlus,
    respond_to_event_invitation: Calendar,
    // Deliver an existing file over Telegram (Send documents)
    send_document_to_chat: Send,

    // Action ledger / undo (Double tap W/T #210)
    list_recent_actions: History,
    revoke_action: Undo2,
    thinking: Loader,
    generating_response: Loader,
    __status__: Loader,
};

export const TOOL_COLORS = {
    search_documents:       { bg: 'bg-violet-100 dark:bg-violet-900/30', text: 'text-violet-700 dark:text-violet-300', border: 'border-violet-300 dark:border-violet-600', dot: 'bg-violet-500' },
    search_within_document: { bg: 'bg-violet-100 dark:bg-violet-900/30', text: 'text-violet-700 dark:text-violet-300', border: 'border-violet-300 dark:border-violet-600', dot: 'bg-violet-400' },
    read_document:          { bg: 'bg-purple-100 dark:bg-purple-900/30', text: 'text-purple-700 dark:text-purple-300', border: 'border-purple-300 dark:border-purple-600', dot: 'bg-purple-500' },
    list_documents:         { bg: 'bg-fuchsia-100 dark:bg-fuchsia-900/30', text: 'text-fuchsia-700 dark:text-fuchsia-300', border: 'border-fuchsia-300 dark:border-fuchsia-600', dot: 'bg-fuchsia-500' },
    open_folder:            { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-700 dark:text-amber-300', border: 'border-amber-300 dark:border-amber-600', dot: 'bg-amber-500' },
    move_document:          { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-700 dark:text-amber-300', border: 'border-amber-300 dark:border-amber-600', dot: 'bg-amber-500' },
    research:               { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-700 dark:text-indigo-300', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-500' },
    research_subagent:      { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-700 dark:text-indigo-300', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-400' },
    rulebook_scribe:        { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300', border: 'border-sky-300 dark:border-sky-600', dot: 'bg-sky-500' },
    get_rulebook:           { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300', border: 'border-sky-300 dark:border-sky-600', dot: 'bg-sky-400' },
    edit_rulebook:          { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300', border: 'border-sky-300 dark:border-sky-600', dot: 'bg-sky-600' },
    context_cache:          { bg: 'bg-stone-100 dark:bg-stone-900/30', text: 'text-stone-700 dark:text-stone-300', border: 'border-stone-300 dark:border-stone-600', dot: 'bg-stone-500' },
    light_chat:             { bg: 'bg-cyan-100 dark:bg-cyan-900/30', text: 'text-cyan-700 dark:text-cyan-300', border: 'border-cyan-300 dark:border-cyan-600', dot: 'bg-cyan-500' },
    edit_document:          { bg: 'bg-teal-100 dark:bg-teal-900/30', text: 'text-teal-700 dark:text-teal-300', border: 'border-teal-300 dark:border-teal-600', dot: 'bg-teal-500' },
    create_document:        { bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-700 dark:text-emerald-300', border: 'border-emerald-300 dark:border-emerald-600', dot: 'bg-emerald-500' },
    document_author:        { bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-700 dark:text-emerald-300', border: 'border-emerald-300 dark:border-emerald-600', dot: 'bg-emerald-600' },
    doc_code_worker:        { bg: 'bg-lime-100 dark:bg-lime-900/30', text: 'text-lime-700 dark:text-lime-300', border: 'border-lime-300 dark:border-lime-600', dot: 'bg-lime-600' },
    delete_document:        { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    delete_book:            { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    rename_book:            { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300', border: 'border-sky-300 dark:border-sky-600', dot: 'bg-sky-600' },
    delete_tickets:         { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-600' },
    delete_expenses:        { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    query_conversation_data: { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300', border: 'border-sky-300 dark:border-sky-600', dot: 'bg-sky-500' },
    get_energy_status: { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-700 dark:text-amber-300', border: 'border-amber-300 dark:border-amber-600', dot: 'bg-amber-500' },
    web_search:             { bg: 'bg-cyan-100 dark:bg-cyan-900/30', text: 'text-cyan-700 dark:text-cyan-300', border: 'border-cyan-300 dark:border-cyan-600', dot: 'bg-cyan-500' },
    calculate:              { bg: 'bg-slate-100 dark:bg-slate-800/60', text: 'text-slate-700 dark:text-slate-300', border: 'border-slate-300 dark:border-slate-600', dot: 'bg-slate-500' },
    web_search_grounded:    { bg: 'bg-cyan-100 dark:bg-cyan-900/30', text: 'text-cyan-700 dark:text-cyan-300', border: 'border-cyan-300 dark:border-cyan-600', dot: 'bg-cyan-600' },
    read_link:              { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300', border: 'border-sky-300 dark:border-sky-600', dot: 'bg-sky-500' },
    read_link_url_context:  { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300', border: 'border-sky-300 dark:border-sky-600', dot: 'bg-sky-600' },
    places_lookup:          { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300', border: 'border-sky-300 dark:border-sky-600', dot: 'bg-sky-700' },
    audio_transcription:    { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    embedding_index:        { bg: 'bg-blue-100 dark:bg-blue-900/30', text: 'text-blue-700 dark:text-blue-300', border: 'border-blue-300 dark:border-blue-600', dot: 'bg-blue-500' },
    embedding_query:        { bg: 'bg-blue-100 dark:bg-blue-900/30', text: 'text-blue-700 dark:text-blue-300', border: 'border-blue-300 dark:border-blue-600', dot: 'bg-blue-400' },
    create_calendar_event:  { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-700 dark:text-amber-300', border: 'border-amber-300 dark:border-amber-600', dot: 'bg-amber-600' },
    create_calendar_events: { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-700 dark:text-amber-300', border: 'border-amber-300 dark:border-amber-600', dot: 'bg-amber-600' },
    resolve_calendar_package: { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-700 dark:text-amber-300', border: 'border-amber-300 dark:border-amber-600', dot: 'bg-amber-600' },
    update_calendar_event:  { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-700 dark:text-amber-300', border: 'border-amber-300 dark:border-amber-600', dot: 'bg-amber-500' },
    delete_calendar_event:  { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    delete_calendar_events: { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    list_calendar_events:   { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-600 dark:text-amber-400', border: 'border-amber-300 dark:border-amber-600', dot: 'bg-amber-400' },
    remove_event_invitation:{ bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-600' },
    create_reminder:        { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-400' },
    list_reminders:         { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-600 dark:text-rose-400', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-300' },
    update_reminder:        { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    delete_reminders:       { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-600' },
    // Notes engine (Notes & Reminders — Fase 1)
    create_note:            { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-700 dark:text-amber-300', border: 'border-amber-300 dark:border-amber-600', dot: 'bg-amber-500' },
    list_notes:             { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-600 dark:text-amber-400', border: 'border-amber-300 dark:border-amber-600', dot: 'bg-amber-400' },
    update_note:            { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-700 dark:text-amber-300', border: 'border-amber-300 dark:border-amber-600', dot: 'bg-amber-500' },
    delete_notes:           { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    share_note:             { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-700 dark:text-indigo-300', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-500' },
    create_tasks:           { bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-700 dark:text-emerald-300', border: 'border-emerald-300 dark:border-emerald-600', dot: 'bg-emerald-500' },
    list_tasks:             { bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-600 dark:text-emerald-400', border: 'border-emerald-300 dark:border-emerald-600', dot: 'bg-emerald-400' },
    update_tasks:           { bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-700 dark:text-emerald-300', border: 'border-emerald-300 dark:border-emerald-600', dot: 'bg-emerald-500' },
    delete_tasks:           { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    create_expense:         { bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-700 dark:text-emerald-300', border: 'border-emerald-300 dark:border-emerald-600', dot: 'bg-emerald-600' },
    create_expense_batch:   { bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-700 dark:text-emerald-300', border: 'border-emerald-300 dark:border-emerald-600', dot: 'bg-emerald-600' },
    create_expenses_from_image: { bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-700 dark:text-emerald-300', border: 'border-emerald-300 dark:border-emerald-600', dot: 'bg-emerald-700' },
    assign_expense_to_book: { bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-600 dark:text-emerald-400', border: 'border-emerald-300 dark:border-emerald-600', dot: 'bg-emerald-400' },
    set_transaction_recurrence: { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-600 dark:text-indigo-400', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-400' },
    list_expenses:          { bg: 'bg-lime-100 dark:bg-lime-900/30', text: 'text-lime-700 dark:text-lime-300', border: 'border-lime-300 dark:border-lime-600', dot: 'bg-lime-600' },
    get_expense:            { bg: 'bg-lime-100 dark:bg-lime-900/30', text: 'text-lime-700 dark:text-lime-300', border: 'border-lime-300 dark:border-lime-600', dot: 'bg-lime-500' },
    export_financial_data:  { bg: 'bg-green-100 dark:bg-green-900/30', text: 'text-green-700 dark:text-green-300', border: 'border-green-300 dark:border-green-600', dot: 'bg-green-600' },
    import_transactions_from_spreadsheet: { bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-700 dark:text-emerald-300', border: 'border-emerald-300 dark:border-emerald-600', dot: 'bg-emerald-600' },
    match_documents_to_expenses: { bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-700 dark:text-emerald-300', border: 'border-emerald-300 dark:border-emerald-600', dot: 'bg-emerald-500' },
    update_expense_categories: { bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-700 dark:text-emerald-300', border: 'border-emerald-300 dark:border-emerald-600', dot: 'bg-emerald-500' },
    update_expense: { bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-700 dark:text-emerald-300', border: 'border-emerald-300 dark:border-emerald-600', dot: 'bg-emerald-500' },
    spreadsheet_import_mapping: { bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-700 dark:text-emerald-300', border: 'border-emerald-300 dark:border-emerald-600', dot: 'bg-emerald-400' },
    search_transaction_items: { bg: 'bg-lime-100 dark:bg-lime-900/30', text: 'text-lime-700 dark:text-lime-300', border: 'border-lime-300 dark:border-lime-600', dot: 'bg-lime-400' },
    expense_extraction:     { bg: 'bg-lime-100 dark:bg-lime-900/30', text: 'text-lime-700 dark:text-lime-300', border: 'border-lime-300 dark:border-lime-600', dot: 'bg-lime-500' },
    list_boards:            { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300', border: 'border-sky-300 dark:border-sky-600', dot: 'bg-sky-600' },
    get_board:              { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300', border: 'border-sky-300 dark:border-sky-600', dot: 'bg-sky-500' },
    create_board:           { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300', border: 'border-sky-300 dark:border-sky-600', dot: 'bg-sky-700' },
    rename_board:           { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300', border: 'border-sky-300 dark:border-sky-600', dot: 'bg-sky-600' },
    rename_documents:       { bg: 'bg-teal-100 dark:bg-teal-900/30', text: 'text-teal-700 dark:text-teal-300', border: 'border-teal-300 dark:border-teal-600', dot: 'bg-teal-500' },
    move_column:            { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-600 dark:text-indigo-400', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-500' },
    rename_column:          { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300', border: 'border-sky-300 dark:border-sky-600', dot: 'bg-sky-500' },
    reorder_column:         { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-600 dark:text-indigo-400', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-400' },
    delete_column:          { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    create_board_label:     { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300', border: 'border-sky-300 dark:border-sky-600', dot: 'bg-sky-500' },
    rename_board_label:     { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300', border: 'border-sky-300 dark:border-sky-600', dot: 'bg-sky-500' },
    delete_board_label:     { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    delete_boards:          { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-600' },
    leave_board:            { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    create_ticket:          { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-700 dark:text-indigo-300', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-600' },
    update_ticket:          { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-600 dark:text-indigo-400', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-500' },
    update_tickets:         { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-700 dark:text-indigo-300', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-600' },
    reorder_ticket:         { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-600 dark:text-indigo-400', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-400' },
    delete_ticket:          { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    add_ticket_comment:     { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-600 dark:text-indigo-400', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-400' },
    list_ticket_comments:   { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-600 dark:text-indigo-400', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-400' },
    delete_ticket_comments: { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    attach_document_to_ticket: { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-700 dark:text-indigo-300', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-500' },
    attach_document_to_note:    { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-700 dark:text-amber-300', border: 'border-amber-300 dark:border-amber-600', dot: 'bg-amber-500' },
    attach_documents_to_ticket: { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-700 dark:text-indigo-300', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-500' },
    detach_documents_from_ticket: { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    search_tickets:         { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-700 dark:text-sky-300', border: 'border-sky-300 dark:border-sky-600', dot: 'bg-sky-400' },
    conversation_title:     { bg: 'bg-slate-100 dark:bg-slate-800/30', text: 'text-slate-600 dark:text-slate-400', border: 'border-slate-300 dark:border-slate-600', dot: 'bg-slate-400' },
    create_contact_from_text: { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-700 dark:text-indigo-300', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-500' },
    // Teams (Agenda TO Contacts — Phase C / T5)
    list_teams:             { bg: 'bg-teal-100 dark:bg-teal-900/30', text: 'text-teal-700 dark:text-teal-300', border: 'border-teal-300 dark:border-teal-600', dot: 'bg-teal-500' },
    get_team:               { bg: 'bg-teal-100 dark:bg-teal-900/30', text: 'text-teal-700 dark:text-teal-300', border: 'border-teal-300 dark:border-teal-600', dot: 'bg-teal-500' },
    create_team:            { bg: 'bg-teal-100 dark:bg-teal-900/30', text: 'text-teal-700 dark:text-teal-300', border: 'border-teal-300 dark:border-teal-600', dot: 'bg-teal-600' },
    add_team_members:       { bg: 'bg-teal-100 dark:bg-teal-900/30', text: 'text-teal-600 dark:text-teal-400', border: 'border-teal-300 dark:border-teal-600', dot: 'bg-teal-400' },
    remove_team_member:     { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    leave_team:             { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-400' },
    delete_team:            { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-600' },
    share_document_to_team: { bg: 'bg-teal-100 dark:bg-teal-900/30', text: 'text-teal-700 dark:text-teal-300', border: 'border-teal-300 dark:border-teal-600', dot: 'bg-teal-500' },
    share_book_to_team:     { bg: 'bg-teal-100 dark:bg-teal-900/30', text: 'text-teal-700 dark:text-teal-300', border: 'border-teal-300 dark:border-teal-600', dot: 'bg-teal-500' },
    create_team_event:      { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-700 dark:text-amber-300', border: 'border-amber-300 dark:border-amber-600', dot: 'bg-amber-600' },
    // PAI-to-PAI direct send + Internal Secretary (Agenda TO Contacts Phase D / T6 + T4)
    send_document_to_contact: { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-700 dark:text-indigo-300', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-500' },
    send_contact_card:      { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-700 dark:text-indigo-300', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-400' },
    respond_to_event_invitation: { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-700 dark:text-amber-300', border: 'border-amber-300 dark:border-amber-600', dot: 'bg-amber-500' },
    // Deliver an existing file over Telegram (Send documents)
    send_document_to_chat:  { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-700 dark:text-indigo-300', border: 'border-indigo-300 dark:border-indigo-600', dot: 'bg-indigo-500' },

    // Action ledger / undo (Double tap W/T #210) — read-only slate, destructive rose
    list_recent_actions:    { bg: 'bg-slate-100 dark:bg-slate-800/60', text: 'text-slate-600 dark:text-slate-300', border: 'border-slate-300 dark:border-slate-600', dot: 'bg-slate-400' },
    revoke_action:          { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-700 dark:text-rose-300', border: 'border-rose-300 dark:border-rose-600', dot: 'bg-rose-500' },
    thinking:               { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-600 dark:text-amber-400', border: 'border-amber-300 dark:border-amber-600', dot: 'bg-amber-500' },
    generating_response:    { bg: 'bg-green-100 dark:bg-green-900/30', text: 'text-green-700 dark:text-green-300', border: 'border-green-300 dark:border-green-600', dot: 'bg-green-500' },
    __status__:             { bg: 'bg-gray-100 dark:bg-gray-800/30', text: 'text-gray-600 dark:text-gray-400', border: 'border-gray-300 dark:border-gray-600', dot: 'bg-gray-400' },
};

export const TOOL_DISPLAY_NAMES = {
    search_documents: 'Searching documents',
    search_within_document: 'Searching within document',
    read_document: 'Reading document',
    list_documents: 'Listing documents',
    open_folder: 'Opening folder',
    move_document: 'Filing document',
    research: 'Researching documents',
    research_subagent: 'Research subagent',
    rulebook_scribe: 'Rulebook scribe',
    get_rulebook: 'Reading rulebook',
    edit_rulebook: 'Editing rulebook',
    context_cache: 'Prompt cache',
    light_chat: 'Fast-track conversation',
    edit_document: 'Editing document',
    create_document: 'Creating document',
    document_author: 'Authoring document (Pro)',
    doc_code_worker: 'Composing document (code engine)',
    delete_document: 'Deleting document',
    delete_book: 'Deleting book',
    rename_book: 'Renaming book',
    delete_expenses: 'Deleting transactions',
    query_conversation_data: 'Analyzing conversation data',
    get_energy_status: 'Checking energy status',
    web_search: 'Web search',
    calculate: 'Calculating',
    web_search_grounded: 'Web search (grounded)',
    read_link: 'Reading link',
    read_link_url_context: 'Reading link (URL context)',
    places_lookup: 'Looking up the place (Google Maps)',
    audio_transcription: 'Transcribing audio',
    embedding_index: 'Embedding (index)',
    embedding_query: 'Embedding (query)',
    create_calendar_event: 'Creating calendar event',
    create_calendar_events: 'Creating calendar events',
    resolve_calendar_package: 'Updating calendar events',
    update_calendar_event: 'Updating calendar event',
    delete_calendar_event: 'Deleting calendar event',
    delete_calendar_events: 'Deleting calendar events',
    list_calendar_events: 'Reading calendar',
    remove_event_invitation: 'Removing guest',
    create_reminder: 'Setting reminder',
    list_reminders: 'Reading reminders',
    update_reminder: 'Updating reminder',
    delete_reminders: 'Deleting reminders',
    // Notes engine (Notes & Reminders — Fase 1)
    create_note: 'Saving note',
    list_notes: 'Reading notes',
    update_note: 'Updating note',
    delete_notes: 'Deleting notes',
    share_note: 'Sharing note',
    create_tasks: 'Adding tasks',
    list_tasks: 'Reading task list',
    update_tasks: 'Updating tasks',
    delete_tasks: 'Deleting tasks',
    create_expense: 'Logging expense',
    create_expense_batch: 'Logging receipts (dedup)',
    create_expenses_from_image: 'Logging receipts (multi)',
    assign_expense_to_book: 'Moving expense',
    set_transaction_recurrence: 'Setting recurrence',
    list_expenses: 'Reading expenses',
    get_expense: 'Reading transaction',
    export_financial_data: 'Exporting finances',
    import_transactions_from_spreadsheet: 'Importing spreadsheet',
    match_documents_to_expenses: 'Matching documents to expenses',
    update_expense_categories: 'Updating transaction categories',
    update_expense: 'Editing transaction',
    spreadsheet_import_mapping: 'Reading spreadsheet columns',
    search_transaction_items: 'Searching line items',
    expense_extraction: 'Reading receipt',
    list_boards: 'Listing boards',
    get_board: 'Reading board',
    create_board: 'Creating board',
    rename_board: 'Renaming board',
    rename_documents: 'Renaming files',
    delete_boards: 'Deleting boards',
    leave_board: 'Leaving board',
    move_column: 'Moving column',
    rename_column: 'Renaming column',
    reorder_column: 'Reordering column',
    delete_column: 'Deleting column',
    create_board_label: 'Creating label',
    rename_board_label: 'Renaming label',
    delete_board_label: 'Deleting label',
    create_ticket: 'Adding ticket',
    update_ticket: 'Updating ticket',
    update_tickets: 'Batch-updating tickets',
    reorder_ticket: 'Reordering ticket',
    delete_ticket: 'Deleting ticket',
    delete_tickets: 'Deleting tickets',
    add_ticket_comment: 'Commenting on ticket',
    list_ticket_comments: 'Reading ticket comments',
    delete_ticket_comments: 'Deleting ticket comments',
    attach_document_to_ticket: 'Attaching to ticket',
    attach_document_to_note: 'Attaching to note',
    attach_documents_to_ticket: 'Attaching to ticket',
    detach_documents_from_ticket: 'Detaching from ticket',
    search_tickets: 'Searching tickets',
    conversation_title: 'Naming conversation',
    create_contact_from_text: 'Preparing contact',
    // Teams (Agenda TO Contacts — Phase C / T5)
    list_teams: 'Listing teams',
    get_team: 'Reading team',
    create_team: 'Creating team',
    add_team_members: 'Adding team members',
    remove_team_member: 'Removing team member',
    leave_team: 'Leaving team',
    delete_team: 'Deleting team',
    share_document_to_team: 'Sharing to team',
    share_book_to_team: 'Sharing book to team',
    create_team_event: 'Creating team event',
    // PAI-to-PAI direct send + Internal Secretary (Agenda TO Contacts Phase D / T6 + T4)
    send_document_to_contact: 'Sending document',
    send_contact_card: 'Sending contact card',
    respond_to_event_invitation: 'Responding to invitation',
    // Deliver an existing file over Telegram (Send documents)
    send_document_to_chat: 'Sending file to chat',

    // Action ledger / undo (Double tap W/T #210)
    list_recent_actions: 'Reviewing recent actions',
    revoke_action: 'Undoing an action',
    thinking: 'Thinking',
    generating_response: 'Generating response',
    __status__: 'Processing',
};

// ─────────────────────────────────────────────────────────────────────────────
// Spanish tool labels ("Spanish" full-localization bug card).
//
// These live HERE rather than in src/i18n/index.jsx on purpose: CLAUDE.md's
// "Adding a new tool" checklist already sends a developer to this file to register
// TOOL_ICONS / TOOL_COLORS / TOOL_DISPLAY_NAMES, so the translation sits in the one
// place they are guaranteed to be looking. `i18n.test.js` asserts this map stays in
// exact parity with TOOL_DISPLAY_NAMES, so a tool added without a translation fails
// CI instead of quietly rendering English inside a Spanish session.
//
// The keys are BACKEND pipeline_step / tool ids — never translate a key.
export const TOOL_DISPLAY_NAMES_ES = {
    search_documents: 'Buscando documentos',
    search_within_document: 'Buscando dentro del documento',
    read_document: 'Leyendo documento',
    list_documents: 'Listando documentos',
    open_folder: 'Abriendo carpeta',
    move_document: 'Archivando documento',
    research: 'Investigando documentos',
    research_subagent: 'Subagente de investigación',
    rulebook_scribe: 'Escriba del reglamento',
    get_rulebook: 'Leyendo reglamento',
    edit_rulebook: 'Editando reglamento',
    context_cache: 'Caché del prompt',
    light_chat: 'Conversación de vía rápida',
    edit_document: 'Editando documento',
    create_document: 'Creando documento',
    document_author: 'Redactando documento (Pro)',
    doc_code_worker: 'Componiendo documento (motor de código)',
    delete_document: 'Eliminando documento',
    delete_book: 'Eliminando libro',
    rename_book: 'Renombrando libro',
    delete_expenses: 'Eliminando transacciones',
    query_conversation_data: 'Analizando datos de la conversación',
    get_energy_status: 'Consultando el estado de energía',
    web_search: 'Búsqueda web',
    calculate: 'Calculando',
    web_search_grounded: 'Búsqueda web (contrastada)',
    read_link: 'Leyendo enlace',
    read_link_url_context: 'Leyendo enlace (contexto de URL)',
    places_lookup: 'Buscando el lugar (Google Maps)',
    audio_transcription: 'Transcribiendo audio',
    embedding_index: 'Indexando (embeddings)',
    embedding_query: 'Consultando (embeddings)',
    create_calendar_event: 'Creando evento de calendario',
    create_calendar_events: 'Creando eventos de calendario',
    resolve_calendar_package: 'Actualizando eventos de calendario',
    update_calendar_event: 'Actualizando evento de calendario',
    delete_calendar_event: 'Eliminando evento de calendario',
    delete_calendar_events: 'Eliminando eventos de calendario',
    list_calendar_events: 'Leyendo el calendario',
    remove_event_invitation: 'Quitando invitado',
    create_reminder: 'Creando recordatorio',
    list_reminders: 'Leyendo recordatorios',
    update_reminder: 'Actualizando recordatorio',
    delete_reminders: 'Eliminando recordatorios',
    // Motor de notas (Notas y Recordatorios — Fase 1)
    create_note: 'Guardando nota',
    list_notes: 'Leyendo notas',
    update_note: 'Actualizando nota',
    delete_notes: 'Eliminando notas',
    share_note: 'Compartiendo nota',
    create_tasks: 'Añadiendo tareas',
    list_tasks: 'Leyendo la lista de tareas',
    update_tasks: 'Actualizando tareas',
    delete_tasks: 'Eliminando tareas',
    create_expense: 'Registrando gasto',
    create_expense_batch: 'Registrando recibos (sin duplicados)',
    create_expenses_from_image: 'Registrando recibos (múltiples)',
    assign_expense_to_book: 'Moviendo gasto',
    set_transaction_recurrence: 'Configurando recurrencia',
    list_expenses: 'Leyendo gastos',
    get_expense: 'Leyendo transacción',
    export_financial_data: 'Exportando finanzas',
    import_transactions_from_spreadsheet: 'Importando hoja de cálculo',
    match_documents_to_expenses: 'Vinculando documentos a gastos',
    update_expense_categories: 'Actualizando categorías de transacciones',
    update_expense: 'Editando transacción',
    spreadsheet_import_mapping: 'Leyendo columnas de la hoja',
    search_transaction_items: 'Buscando líneas de detalle',
    expense_extraction: 'Leyendo recibo',
    list_boards: 'Listando tableros',
    get_board: 'Leyendo tablero',
    create_board: 'Creando tablero',
    rename_board: 'Renombrando tablero',
    rename_documents: 'Renombrando archivos',
    delete_boards: 'Eliminando tableros',
    leave_board: 'Saliendo del tablero',
    move_column: 'Moviendo columna',
    rename_column: 'Renombrando columna',
    reorder_column: 'Reordenando columna',
    delete_column: 'Eliminando columna',
    create_board_label: 'Creando etiqueta',
    rename_board_label: 'Renombrando etiqueta',
    delete_board_label: 'Eliminando etiqueta',
    create_ticket: 'Añadiendo ticket',
    update_ticket: 'Actualizando ticket',
    update_tickets: 'Actualizando tickets en lote',
    reorder_ticket: 'Reordenando ticket',
    delete_ticket: 'Eliminando ticket',
    delete_tickets: 'Eliminando tickets',
    add_ticket_comment: 'Comentando en el ticket',
    list_ticket_comments: 'Leyendo comentarios del ticket',
    delete_ticket_comments: 'Eliminando comentarios del ticket',
    attach_document_to_ticket: 'Adjuntando al ticket',
    attach_document_to_note: 'Adjuntando a la nota',
    attach_documents_to_ticket: 'Adjuntando al ticket',
    detach_documents_from_ticket: 'Quitando del ticket',
    search_tickets: 'Buscando tickets',
    conversation_title: 'Nombrando la conversación',
    create_contact_from_text: 'Preparando contacto',
    // Equipos (Agenda TO Contacts — Fase C / T5)
    list_teams: 'Listando equipos',
    get_team: 'Leyendo equipo',
    create_team: 'Creando equipo',
    add_team_members: 'Añadiendo miembros al equipo',
    remove_team_member: 'Quitando miembro del equipo',
    leave_team: 'Saliendo del equipo',
    delete_team: 'Eliminando equipo',
    share_document_to_team: 'Compartiendo con el equipo',
    share_book_to_team: 'Compartiendo libro con el equipo',
    create_team_event: 'Creando evento de equipo',
    // Envío directo PAI-a-PAI + Secretaría Interna (Fase D / T6 + T4)
    send_document_to_contact: 'Enviando documento',
    send_contact_card: 'Enviando tarjeta de contacto',
    respond_to_event_invitation: 'Respondiendo a la invitación',
    // Entregar un archivo por Telegram
    send_document_to_chat: 'Enviando archivo al chat',
    // Registro de acciones / deshacer (Double tap W/T #210)
    list_recent_actions: 'Revisando acciones recientes',
    revoke_action: 'Deshaciendo una acción',
    thinking: 'Pensando',
    generating_response: 'Generando respuesta',
    __status__: 'Procesando',
};

/**
 * The localized label for a tool / pipeline_step.
 *
 * Falls back through Spanish → English → the raw id, so an unrecognised step (a
 * backend tool the frontend has not registered yet) still renders something
 * meaningful instead of blank.
 */
export function toolDisplayName(tool, language = 'en') {
    const dict = language === 'es' ? TOOL_DISPLAY_NAMES_ES : TOOL_DISPLAY_NAMES;
    return dict[tool] || TOOL_DISPLAY_NAMES[tool] || tool;
}
